import Rest from '@/services/Rest';

/**
 * @typedef {ShippingService}
 */
export default class ShippingService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/envios'
}